export default __webpack_public_path__ + "static/media/email.b5eaaaba.svg";